// Esqueletos do tema; utils.ts reexporta tudo daqui.

import app from 'flarum/forum/app';

// Espelha o ThreadCard: cabeça (avatar, texto, ações) e linha de números.
export const renderThreadSkeleton = (count = 3) => Array.from({
  length: count
}, (_, i) => m('div', {
  key: i,
  className: 'AvocadoHome-skeletonCard'
}, [m('div', {
  className: 'AvocadoHome-skeletonHead'
}, [m('div', {
  className: 'AvocadoHome-skeletonAvatar'
}), m('div', {
  className: 'AvocadoHome-skeletonBody'
}, [m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoHome-skeletonLine--meta'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoHome-skeletonLine--title'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoHome-skeletonLine--excerpt'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoHome-skeletonLine--excerpt2'
})]), m('div', {
  className: 'AvocadoHome-skeletonActions'
},
// O conteúdo escondido dá a largura natural; o CSS esconde os filhos e deixa só
// o brilho do wrapper.
m('div', {
  className: 'AvocadoHome-skeletonActions-reply',
  'aria-hidden': 'true'
}, [m('i', {
  className: 'fas fa-reply',
  'aria-hidden': 'true'
}), m('span', {}, app.translator.trans('ramon-avocado.forum.home.reply_label'))]))]), m('div', {
  className: 'AvocadoHome-skeletonStats'
}, [m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoHome-skeletonLine--stat'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoHome-skeletonLine--stat'
})])]));
export const renderDiscSkeleton = renderThreadSkeleton;

// Um esqueleto montado com a marcação real do que vai substituí-lo herda caixa,
// recuo e espaçamento do CSS de verdade, em qualquer largura, sem números
// copiados à mão. Só o texto vira osso.

/** Uma linha de texto em osso, dentro de um elemento real. */
export const bone = width => m('span', {
  className: 'AvocadoBone AvocadoBone--text',
  style: {
    width
  }
}, ' ');

/** Classes de um elemento real pintado inteiro como osso (avatar, botão, pílula): o conteúdo só dá a largura. */
export const BONE_FILL = 'AvocadoBone AvocadoBone--fill';

// Cartões das abas do perfil: PostCard e ThreadCard. As larguras variam por
// cartão para não parecer carimbo.
const PROFILE_TITLES = ['34%', '22%', '46%'];
const PROFILE_EXCERPTS = [['72%'], ['100%', '38%'], ['88%']];
export const renderProfileCardSkeleton = (kind = 'post', count = 3, bookmark = false) => Array.from({
  length: count
}, (_, i) => {
  const post = kind === 'post';
  // Para quem está logado o cartão real reserva o lugar dos controles (⋮) e,
  // no ThreadCard com os salvos ligados (`bookmark`), o do botão de salvar —
  // os dois só aparecem no hover, mas ocupam largura.
  const controls = !!app.session.user;
  return m('div', {
    key: i,
    className: 'AvocadoHome-threadCard AvocadoHome-threadCard--skeleton',
    'aria-hidden': 'true'
  }, [m('div', {
    className: 'AvocadoHome-threadHead'
  }, [m('div', {
    className: `AvocadoHome-avatarWrap ${BONE_FILL}`
  }), m('div', {
    className: 'AvocadoHome-threadMain'
  }, [m('div', {
    className: 'AvocadoHome-threadMeta'
  }, [m('span', {
    className: 'AvocadoHome-threadAuthor'
  }, bone('86px')), m('span', {
    className: 'AvocadoHome-threadTime'
  }, bone('48px')),
  // Só o PostCard mostra as tags da discussão na linha do autor.
  post && m('span', {
    className: `AvocadoHome-tagPill ${BONE_FILL}`
  }, bone('84px')), post && m('span', {
    className: `AvocadoHome-tagPill ${BONE_FILL}`
  }, bone('62px'))]), m('span', {
    className: 'AvocadoHome-threadTitle'
  }, bone(PROFILE_TITLES[i % PROFILE_TITLES.length])), m('p', {
    className: `AvocadoHome-threadExcerpt${post ? ' AvocadoUserPage-postExcerpt' : ''}`
  }, PROFILE_EXCERPTS[i % PROFILE_EXCERPTS.length].map(width => bone(width)))]), m('div', {
    className: 'AvocadoHome-threadActions'
  }, [!post && controls && bookmark && m('span', {
    className: 'AvocadoThreadCard-bookmarkBtn AvocadoBone'
  }), controls && m('span', {
    className: 'AvocadoHome-threadControls-toggle AvocadoBone'
  }),
  // O botão de verdade, com ícone e rótulo traduzido escondidos: a largura é a dele.
  m('span', {
    className: `AvocadoHome-replyBtn ${BONE_FILL}`
  }, [m('i', {
    className: post ? 'fas fa-arrow-right' : 'fas fa-reply'
  }),
  // Num <span>: texto solto não é filho que o osso consiga esconder.
  m('span', {}, app.translator.trans(post ? 'ramon-avocado.forum.home.view' : 'ramon-avocado.forum.home.reply_label'))])])]),
  // Última resposta: só o ThreadCard a mostra.
  !post && m('div', {
    className: 'AvocadoHome-threadReplyGroup'
  }, m('div', {
    className: 'AvocadoHome-replyCard'
  }, [m('span', {
    className: 'AvocadoHome-replyCard-line'
  }, [m('div', {
    className: `AvocadoHome-replyCard-avatar ${BONE_FILL}`
  }), m('span', {
    className: 'AvocadoHome-replyCard-name'
  }, bone('96px')), m('span', {
    className: 'AvocadoHome-replyCard-text'
  }, bone('70%'))]), m('span', {
    className: 'AvocadoHome-replyCard-seeMore'
  }, bone('148px'))])), m('div', {
    className: 'AvocadoHome-threadStats'
  }, [!post && m('span', {
    className: 'AvocadoHome-statBtn'
  }, bone('70px')), m('span', {
    className: 'AvocadoHome-statBtn'
  }, bone('84px'))])]);
});

// Espelha o AvocadoSearch-postCard.
export const renderPostSkeleton = (count = 3) => Array.from({
  length: count
}, (_, i) => m('div', {
  key: i,
  className: 'AvocadoSearch-postSkeleton'
}, [m('div', {
  className: 'AvocadoSearch-postSkeleton-head'
}, [m('div', {
  className: 'AvocadoSearch-postSkeleton-avatar'
}), m('div', {
  className: 'AvocadoSearch-postSkeleton-meta'
}, [m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoHome-skeletonLine--sm'
}), m('div', {
  className: 'AvocadoHome-skeletonLine',
  style: 'height:10px;width:70px'
})])]), m('div', {
  className: 'AvocadoSearch-postSkeleton-pill'
}), m('div', {
  className: 'AvocadoSearch-postSkeleton-excerpt'
}, [m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoHome-skeletonLine--md'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoHome-skeletonLine--sm'
})])]));
export const renderShowcaseSkeleton = count => Array.from({
  length: count
}, (_, i) => m('div', {
  key: i,
  className: 'AvocadoHome-showcaseSkeleton'
}));

// Espelha Page-sidebar > DiscussionPage-nav; guests não têm Responder nem Seguir.
export const renderDiscussionNavSkeleton = (isLoggedIn = true) => m('div', {
  className: 'Page-sidebar'
}, m('nav', {
  className: 'DiscussionPage-nav'
}, m('ul', {}, [...(isLoggedIn ? [m('li', {
  className: 'item-controls'
}, m('div', {
  className: 'AvocadoSkeleton-navSplitMain AvocadoSkeleton-navSplitMain--primary'
})), m('li', {
  className: 'item-subscription'
}, m('div', {
  className: 'AvocadoSkeleton-navSplitMain AvocadoSkeleton-navSplitMain--secondary'
}))] : []), m('li', {
  className: 'item-scrubber'
}, m('div', {
  className: 'AvocadoSkeleton-navScrubber'
}))])));

// Esqueletos do linkrobins/support: usam as classes da própria extensão para
// herdar moldura, recuo e divisórias do conteúdo real.

export const renderSupportListSkeleton = (count = 5) => m('div', {
  className: 'LinkRobinsSupport-list AvocadoSupport-skeletonList'
}, Array.from({
  length: count
}, (_, i) => m('div', {
  key: i,
  className: 'LinkRobinsSupport-row AvocadoSupport-skeletonRow'
}, [m('div', {
  className: 'LinkRobinsSupport-row-main'
}, [m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--subject'
}), m('div', {
  className: 'AvocadoSupport-skeletonMeta'
}, [m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--metaCat'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--metaUser'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--metaDate'
})])]), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--status'
})])));
export const renderSupportTicketSkeleton = (count = 3) => m('div', {
  className: 'AvocadoSupport-skeletonTicket'
}, [m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--ticketMeta'
}), m('div', {
  className: 'LinkRobinsSupport-replies'
}, Array.from({
  length: count
}, (_, i) => m('div', {
  key: i,
  className: 'LinkRobinsSupport-reply AvocadoSupport-skeletonReply'
}, [m('div', {
  className: 'AvocadoSupport-skeletonMeta'
}, [m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--metaUser'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--metaDate'
})]), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--body'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--bodyShort'
})])))]);
export const renderSupportCategoriesSkeleton = (count = 3) => m('div', {
  className: 'AvocadoSupport-skeletonCategories'
}, Array.from({
  length: count
}, (_, i) => m('div', {
  key: i,
  className: 'LinkRobinsSupport-categoryCard AvocadoSupport-skeletonCategory'
}, [m('div', {
  className: 'AvocadoSupport-skeletonCategory-icon'
}), m('div', {
  className: 'AvocadoSupport-skeletonCategory-text'
}, [m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--catName'
}), m('div', {
  className: 'AvocadoHome-skeletonLine AvocadoSupport-skeletonLine--catDesc'
})])])));
flarum.reg.add('ramon-avocado', 'forum/components/Skeletons', { renderThreadSkeleton: renderThreadSkeleton,renderDiscSkeleton: renderDiscSkeleton,bone: bone,BONE_FILL: BONE_FILL,renderProfileCardSkeleton: renderProfileCardSkeleton,renderPostSkeleton: renderPostSkeleton,renderShowcaseSkeleton: renderShowcaseSkeleton,renderDiscussionNavSkeleton: renderDiscussionNavSkeleton,renderSupportListSkeleton: renderSupportListSkeleton,renderSupportTicketSkeleton: renderSupportTicketSkeleton,renderSupportCategoriesSkeleton: renderSupportCategoriesSkeleton, });